/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCampaignFromJSON, ApiCampaignToJSON, } from './ApiCampaign';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiUserFromJSON, ApiUserToJSON, } from './ApiUser';
export function ApiCampaignSplitUrlFromJSON(json) {
    return ApiCampaignSplitUrlFromJSONTyped(json, false);
}
export function ApiCampaignSplitUrlFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'campaign': !exists(json, 'campaign') ? undefined : ApiCampaignFromJSON(json['campaign']),
        'campaignId': !exists(json, 'campaignId') ? undefined : json['campaignId'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lastUser': !exists(json, 'lastUser') ? undefined : ApiUserFromJSON(json['lastUser']),
        'lastUserId': !exists(json, 'lastUserId') ? undefined : json['lastUserId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'owner': !exists(json, 'owner') ? undefined : ApiUserFromJSON(json['owner']),
        'ownerId': !exists(json, 'ownerId') ? undefined : json['ownerId'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}
export function ApiCampaignSplitUrlToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'campaign': ApiCampaignToJSON(value.campaign),
        'campaignId': value.campaignId,
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'id': value.id,
        'lastUser': ApiUserToJSON(value.lastUser),
        'lastUserId': value.lastUserId,
        'name': value.name,
        'owner': ApiUserToJSON(value.owner),
        'ownerId': value.ownerId,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'url': value.url,
    };
}
